import React, { useRef, useEffect, useState, useCallback } from "react";
import "./gullidanda.css";
import GulliDandaAbout from "./GulliDandaAbout";

const COMPUTER_PLAYERS = [
  { name: "Raju", skill: 0.85, emoji: "😎" },
  { name: "Sita", skill: 0.78, emoji: "👩" },
  { name: "Aman", skill: 0.82, emoji: "🧔" },
  { name: "Ali", skill: 0.75, emoji: "🧔‍♂️" },
  { name: "Joseph", skill: 0.70, emoji: "🙋‍♂️" },
  { name: "Benjamin", skill: 0.88, emoji: "🧓" },
  { name: "Vikram", skill: 0.80, emoji: "🏋️" },
  { name: "Chan", skill: 0.72, emoji: "🧑‍🚀" },
  { name: "Toyoda", skill: 0.90, emoji: "🤖" },
];

const POWER_UPS = [
  { id: "double", name: "🔥 Double Distance", effect: "double" },
  { id: "slow", name: "⏳ Slow Motion Bar", effect: "slow" },
  { id: "extra", name: "➕ Extra Attempt", effect: "extra" },
];

const ACHIEVEMENTS = [
  { id: "perfect5", name: "Perfect 5 Hits", desc: "5 hits with >85% accuracy", icon: "🌟" },
  { id: "beatToyoda", name: "Beat Toyoda", desc: "Score higher than Toyoda", icon: "🏆" },
  { id: "century", name: "Century Club", desc: "1000+ in one game", icon: "💯" },
  { id: "master", name: "Master Striker", desc: "Career score > 5000", icon: "👑" },
];

const COMMENTS = ["🔥 Kya shot hai!", "💥 Zabardast!", "🏏 Full power!", "🚀 Gayi bahar!"];
const HINDI_COMMENTS = ["क्या शॉट है!", "जबरदस्त!", "पूरा दम लगाओ!", "गेंद बाहर चली गई!"];

const TUTORIAL_STEPS = [
  "👋 Welcome to Gulli Danda!",
  "👆 Tap anywhere to lift the gulli",
  "⏳ Wait for the right moment...",
  "🔥 Tap again to HIT!",
  "🎯 Best when power is in the middle",
  "🏆 Beat computer players & unlock rewards!",
];

const GulliDandaGame = () => {
  const canvasRef = useRef(null);
  const audioCtxRef = useRef(null);
  const crowdGainRef = useRef(null);
  const replayCanvasRef = useRef(null);

  const [soundOn, setSoundOn] = useState(false);
  const [soundPack, setSoundPack] = useState("desi"); // desi or modern

  const [score, setScore] = useState(0);
  const [attempts, setAttempts] = useState(5);
  const [gameState, setGameState] = useState("setup"); // setup | idle | lift | hit | result | gameover
  const [feedback, setFeedback] = useState("");
  const [power, setPower] = useState(0);
  const [gulliY, setGulliY] = useState(0);
  const [impact, setImpact] = useState(false);
  const [shake, setShake] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);

  const [selectedOpponents, setSelectedOpponents] = useState(COMPUTER_PLAYERS.slice(0, 3));
  const [liveOpponentScores, setLiveOpponentScores] = useState([]); // tracks current scores during match
  const [showOpponentAction, setShowOpponentAction] = useState(null); // {name, emoji, points, newScore}
  const [opponentScores, setOpponentScores] = useState([]);
  const [wind, setWind] = useState(0);

  const [powerUp, setPowerUp] = useState(null);
  const [powerUpAvailable, setPowerUpAvailable] = useState(false);
  const [doubleNext, setDoubleNext] = useState(false);
  const [slowMotion, setSlowMotion] = useState(false);

  const [showHistory, setShowHistory] = useState(false);
  const [gameHistory, setGameHistory] = useState([]); // Array of turn records

  // ==================== HISTORY TRACKER ====================
  const recordTurnHistory = useCallback((yourTurnPoints) => {
    const currentTurn = {
      turn: gameHistory.length + 1,
      yourScore: score + yourTurnPoints,
      yourPointsThisTurn: yourTurnPoints,
      opponents: liveOpponentScores.map(opp => ({
        name: opp.name,
        emoji: opp.emoji,
        score: opp.score
      })),
      timestamp: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
    };

    setGameHistory(prev => [...prev, currentTurn]);
  }, [score, liveOpponentScores, gameHistory.length]);

  const [perfectHits, setPerfectHits] = useState(0);
  const [bestFlight, setBestFlight] = useState(null); // {distance, path}
  const [showReplay, setShowReplay] = useState(false);
  const [replayPath, setReplayPath] = useState([]);
  const [replayProgress, setReplayProgress] = useState(0);

  const [unlockedAchievements, setUnlockedAchievements] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("gd_achievements") || "[]");
    } catch {
      return [];
    }
  });

  const [totalCareerScore, setTotalCareerScore] = useState(
    Number(localStorage.getItem("gd_career_score")) || 0
  );

  const [bestScore, setBestScore] = useState(
    Number(localStorage.getItem("gd_best")) || 0
  );

  const [hint, setHint] = useState("");

  useEffect(() => {
  if (gameState === "idle") {
    setHint("👆 Tap to lift the gulli");
  } else if (gameState === "lift") {
    setHint("⏳ Wait... get ready to hit");
  } else if (gameState === "hit") {
    setHint("🔥 Tap when bar is in the middle");
  } else if (gameState === "result") {
    setHint("📊 Watch result & prepare next");
  }
}, [gameState]);

  const [showAbout, setShowAbout] = useState(false);
  const [showTutorial, setShowTutorial] = useState(!localStorage.getItem("gd_tutorial_done"));
  const [tutorialStep, setTutorialStep] = useState(0);

  // Audio Context
  const getAudioCtx = useCallback(() => {
    if (!audioCtxRef.current) {
      audioCtxRef.current = new (window.AudioContext || window.webkitAudioContext)();
    }
    return audioCtxRef.current;
  }, []);

  // Crowd noise
  useEffect(() => {
    if (!soundOn) return;
    const ctx = getAudioCtx();
    const buffer = ctx.createBuffer(1, ctx.sampleRate * 3, ctx.sampleRate);
    const data = buffer.getChannelData(0);
    for (let i = 0; i < data.length; i++) data[i] = (Math.random() * 2 - 1) * 0.55;

    const noise = ctx.createBufferSource();
    noise.buffer = buffer;
    noise.loop = true;

    const gain = ctx.createGain();
    gain.gain.value = 0.03;

    noise.connect(gain);
    gain.connect(ctx.destination);
    noise.start();

    crowdGainRef.current = gain;

    return () => {
      try { noise.stop(); } catch {}
    };
  }, [soundOn, getAudioCtx]);

  const crowdCheer = useCallback((intensity = 0.1) => {
    if (!soundOn || !crowdGainRef.current) return;
    const ctx = getAudioCtx();
    const now = ctx.currentTime;
    const boost = soundPack === "desi" ? intensity * 1.5 : intensity;

    crowdGainRef.current.gain.cancelScheduledValues(now);
    crowdGainRef.current.gain.linearRampToValueAtTime(0.4 + boost, now + 0.1);
    crowdGainRef.current.gain.linearRampToValueAtTime(0.03, now + 1.3);
  }, [soundOn, soundPack, getAudioCtx]);

  const playTone = useCallback((freq = 440, duration = 0.1, type = "sine", pan = 0) => {
    if (!soundOn) return;
    const ctx = getAudioCtx();
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    const panner = ctx.createStereoPanner();

    osc.type = type;
    osc.frequency.value = soundPack === "desi" ? freq * 1.12 : freq;
    panner.pan.value = pan;

    osc.connect(panner);
    panner.connect(gain);
    gain.connect(ctx.destination);

    gain.gain.setValueAtTime(soundPack === "desi" ? 0.35 : 0.25, ctx.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + duration);

    osc.start();
    osc.stop(ctx.currentTime + duration);
  }, [soundOn, soundPack, getAudioCtx]);

  // Speech
  const speak = useCallback((text, isHindi = false) => {
    if (!soundOn || !window.speechSynthesis) return;
    const utter = new SpeechSynthesisUtterance(text);
    utter.rate = 1.05;
    utter.pitch = 1.1;
    if (isHindi) {
      const voices = window.speechSynthesis.getVoices();
      const hindiVoice = voices.find(v => v.lang.includes("hi")) || voices[0];
      if (hindiVoice) utter.voice = hindiVoice;
    }
    window.speechSynthesis.cancel();
    window.speechSynthesis.speak(utter);
  }, [soundOn]);

  // Power bar
  useEffect(() => {
    let interval;
    if (gameState === "hit") {
      let direction = 1;
      const step = slowMotion ? 3 : 5.5;
      interval = setInterval(() => {
        setPower(prev => {
          let next = prev + direction * step;
          if (next >= 100) direction = -1;
          if (next <= 0) direction = 1;
          return Math.max(0, Math.min(100, next));
        });
      }, 45);
    }
    return () => clearInterval(interval);
  }, [gameState, slowMotion]);

  const generateWind = () => (Math.random() * 16 - 8).toFixed(1);

  const triggerPowerUpOffer = () => {
    if ((5 - attempts) % 3 === 0 && attempts < 5 && gameState === "idle") {
      const pu = POWER_UPS[Math.floor(Math.random() * POWER_UPS.length)];
      setPowerUp(pu);
      setPowerUpAvailable(true);
      setTimeout(() => setPowerUp(null), 4500);
    }
  };

  const applyPowerUp = (pu) => {
    if (pu.effect === "double") setDoubleNext(true);
    else if (pu.effect === "slow") setSlowMotion(true);
    else if (pu.effect === "extra") setAttempts(a => a + 1);

    setPowerUpAvailable(false);
    setPowerUp(null);
    setTimeout(() => setSlowMotion(false), 8000); // slow lasts 8 seconds
  };

  const handleTap = useCallback(() => {
    if (isAnimating || attempts <= 0 || gameState === "gameover") return;

    const ctx = getAudioCtx();
    if (ctx.state === "suspended") ctx.resume();

    playTone(320, 0.06, "square");
    playTone(680, 0.12, "sine");

    if (showTutorial) {
      if (tutorialStep < TUTORIAL_STEPS.length - 1) {
        setTutorialStep(p => p + 1);
      } else {
        setShowTutorial(false);
        localStorage.setItem("gd_tutorial_done", "true");
      }
      return;
    }

    if (navigator.vibrate) navigator.vibrate(25);

    if (gameState === "idle") {
      setFeedback("👆 Tap again to HIT!");
      setGameState("lift");

      let lift = 0;
      const liftInt = setInterval(() => {
        lift += 6;
        setGulliY(lift);
        if (lift >= 55) {
          clearInterval(liftInt);
          setGameState("hit");
          setFeedback("🔥 Tap when bar is in middle!");
        }
      }, 16);
    } else if (gameState === "hit") {
      setIsAnimating(true);
      const accuracy = Math.max(0, 1 - Math.abs(power - 50) / 50);
      let distance = Math.floor(accuracy * 30 + 12);

      const currentWind = parseFloat(wind);
      distance = Math.floor(distance * (1 + currentWind / 100));

      if (doubleNext) {
        distance = Math.floor(distance * 2);
        setDoubleNext(false);
      }

      const isPerfect = accuracy > 0.85;
      if (isPerfect) setPerfectHits(p => p + 1);

      let comment = COMMENTS[Math.floor(Math.random() * COMMENTS.length)];
      setFeedback(comment);

      if (accuracy > 0.9) {
        crowdCheer(0.75);
        playTone(850, 0.25, "sine");
        setTimeout(() => playTone(1100, 0.2, "sine"), 100);
        speak("Shandaar shot!", true);
      } else if (accuracy > 0.6) {
        crowdCheer(0.4);
        speak(HINDI_COMMENTS[Math.floor(Math.random() * HINDI_COMMENTS.length)], true);
      } else {
        crowdCheer(0.15);
      }

      triggerEffects(accuracy > 0.9);

      // Record flight for replay
      const flightPath = [];
      let y = gulliY;
      let v = accuracy * 20 + 5;
      const gravity = 0.65;
      const resistance = 0.985;

      const flightInterval = setInterval(() => {
        y += v;
        v = v * resistance - gravity;
        flightPath.push(y);
        setGulliY(y);

        if (y <= 0) {
          clearInterval(flightInterval);
          const finalDistance = distance;

          setScore(prev => prev + finalDistance);
          setAttempts(prev => prev - 1);
          recordTurnHistory(finalDistance);
          simulateOpponentTurns();

          // Save best flight
          // if (!bestFlight || finalDistance > bestFlight.distance) {
          //   setBestFlight({ distance: finalDistance, path: flightPath });
          // }
          if (!bestFlight || finalDistance > (bestFlight?.distance || 0)) {
            setBestFlight({
              distance: finalDistance,
              path: [...flightPath]   // copy the array
            });
          }

          setGameState("result");
          setTimeout(() => {
            triggerPowerUpOffer();
            if (attempts - 1 <= 0) {
              endGame(finalDistance, flightPath);
            } else {
              resetTurn();
            }
          }, 800);
        }
      }, 16);
    }
  }, [gameState, power, gulliY, attempts, isAnimating, showTutorial, tutorialStep, wind, doubleNext, bestFlight, slowMotion]);

  const triggerEffects = (perfect) => {
    setImpact(true);
    setShake(true);
    if (navigator.vibrate) navigator.vibrate(perfect ? [60, 40, 60] : 55);
    setTimeout(() => { setImpact(false); setShake(false); }, 220);
  };

  const resetTurn = () => {
    setGulliY(0);
    setPower(0);
    setIsAnimating(false);
    setGameState("idle");
    setFeedback("");
    setWind(generateWind());
  };

  // ==================== FIXED endGame FUNCTION ====================
  const endGame = (lastDistance = 0) => {
    const finalYourScore = score + lastDistance;

    setGameState("gameover");

    // Use the REAL final scores from liveOpponentScores (no random regeneration)
    const finalOpponentScores = liveOpponentScores.map(opp => ({
      ...opp,
      score: opp.score || 0   // ensure no undefined
    }));

    setOpponentScores(finalOpponentScores);

    // Update best score
    if (finalYourScore > bestScore) {
      setBestScore(finalYourScore);
      localStorage.setItem("gd_best", finalYourScore);
    }

    // Record the last turn in history (if not already recorded)
    if (lastDistance > 0) {
      recordTurnHistory(lastDistance);
    }

    // Check achievements using final score
    let newUnlocks = [...unlockedAchievements];
    let hasNew = false;

    if (perfectHits >= 5 && !newUnlocks.includes("perfect5")) {
      newUnlocks.push("perfect5");
      hasNew = true;
    }
    if (finalYourScore >= 1000 && !newUnlocks.includes("century")) {
      newUnlocks.push("century");
      hasNew = true;
    }
    const toyoda = finalOpponentScores.find(p => p.name === "Toyoda");
    if (toyoda && finalYourScore > toyoda.score && !newUnlocks.includes("beatToyoda")) {
      newUnlocks.push("beatToyoda");
      hasNew = true;
    }
    if ((totalCareerScore + finalYourScore) > 5000 && !newUnlocks.includes("master")) {
      newUnlocks.push("master");
      hasNew = true;
    }

    if (hasNew) {
      setUnlockedAchievements(newUnlocks);
      localStorage.setItem("gd_achievements", JSON.stringify(newUnlocks));
      triggerConfetti();
    }
  };

  // ==================== LIVE OPPONENT SCORE UPDATE ====================
// Place this function anywhere after your state declarations (best near handleTap or endGame)

  const simulateOpponentTurns = useCallback(async () => {
    if (selectedOpponents.length === 0) return;

    // Initialize live scores on first call
    if (liveOpponentScores.length === 0) {
      const initial = selectedOpponents.map(p => ({
        ...p,
        score: 0 // starting score
        // score: Math.floor(180 + p.skill * 320) 
      }));
      setLiveOpponentScores(initial);
    }

    // Simulate each opponent one by one with delay
    for (const opponent of selectedOpponents) {
      // Simulate shot accuracy based on skill
      const accuracy = Math.max(0.4, opponent.skill - Math.random() * 0.35);
      const points = Math.floor(accuracy * 38 + 18); // 18 to ~55 points per turn

      setShowOpponentAction({
        name: opponent.name,
        emoji: opponent.emoji,
        points: points,
        newScore: 0 // will be updated below
      });

      // Small delay so user can see the action
      await new Promise(resolve => setTimeout(resolve, 650));

      // Update the live score
      setLiveOpponentScores(prev => {
        const updated = prev.map(p => {
          if (p.name === opponent.name) {
            const newScore = p.score + points;
            // Update the popup with correct new score
            setShowOpponentAction({
              name: opponent.name,
              emoji: opponent.emoji,
              points: points,
              newScore: newScore
            });
            return { ...p, score: newScore };
          }
          return p;
        });
        return updated;
      });

      // Hide popup after showing result
      setTimeout(() => {
        setShowOpponentAction(null);
      }, 900);
    }
  }, [selectedOpponents, liveOpponentScores]);

  // Simple Confetti
  const triggerConfetti = () => {
    const canvas = document.createElement("canvas");
    canvas.style.position = "fixed";
    canvas.style.top = "0";
    canvas.style.left = "0";
    canvas.style.zIndex = "100";
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
    document.body.appendChild(canvas);

    const ctx = canvas.getContext("2d");
    const particles = [];
    for (let i = 0; i < 150; i++) {
      particles.push({
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height - canvas.height,
        size: Math.random() * 8 + 4,
        speed: Math.random() * 6 + 4,
        color: ["#ff0", "#f0f", "#0ff", "#0f0"][Math.floor(Math.random()*4)]
      });
    }

    let frame = 0;
    const animate = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      particles.forEach(p => {
        p.y += p.speed;
        ctx.fillStyle = p.color;
        ctx.fillRect(p.x, p.y, p.size, p.size);
      });
      frame++;
      if (frame < 80) requestAnimationFrame(animate);
      else document.body.removeChild(canvas);
    };
    animate();
  };

  // Replay best hit
  // const replayBestHit = () => {
  //   if (!bestFlight) return;
  //   setShowReplay(true);
  //   setReplayProgress(0);

  //   let i = 0;
  //   const replayInterval = setInterval(() => {
  //     if (i < bestFlight.path.length) {
  //       setGulliY(bestFlight.path[i]);
  //       i++;
  //     } else {
  //       clearInterval(replayInterval);
  //       setTimeout(() => {
  //         setShowReplay(false);
  //         setGulliY(0);
  //       }, 600);
  //     }
  //   }, 20);
  // };

  // ==================== FIXED REPLAY BEST HIT ====================
  const replayBestHit = () => {
    if (!bestFlight || !bestFlight.path || bestFlight.path.length === 0) {
      alert("No best hit recorded yet!");
      return;
    }

    setShowReplay(true);
    setReplayPath(bestFlight.path);   // Pass path to replay
    setGulliY(0);                     // Reset position before replay
  };

  // ==================== REPLAY ANIMATION (Separate from main canvas) ====================
  useEffect(() => {
    if (!showReplay || !replayPath.length) return;

    const canvas = replayCanvasRef.current;   // You'll need this ref
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    let i = 0;
    let raf;

    const replayRender = () => {
      const w = canvas.width;
      const h = canvas.height;

      // Clear
      ctx.clearRect(0, 0, w, h);

      // Simple sky + ground for replay
      const grad = ctx.createLinearGradient(0, 0, 0, h);
      grad.addColorStop(0, "#ff9a5c");
      grad.addColorStop(1, "#2a2a3a");
      ctx.fillStyle = grad;
      ctx.fillRect(0, 0, w, h);

      ctx.fillStyle = "#4a2f1f";
      ctx.fillRect(0, h - 48, w, 48);

      // Danda
      ctx.fillStyle = "#8b5a2b";
      ctx.fillRect(w / 2 - 3, h - 105, 6, 48);

      // Gulli - use replayPath
      if (i < replayPath.length) {
        const currentY = replayPath[i];
        ctx.fillStyle = "#f4f4f4";
        ctx.fillRect(w / 2 - 11, h - 62 - currentY, 22, 6);

        // Optional: add impact glow at peak
        if (currentY > 120) {
          ctx.fillStyle = "rgba(255, 230, 100, 0.6)";
          ctx.beginPath();
          ctx.arc(w / 2, h - 80, 18, 0, Math.PI * 2);
          ctx.fill();
        }

        i++;
      } else {
        // End of replay - show final position briefly then close
        ctx.fillStyle = "#f4f4f4";
        ctx.fillRect(w / 2 - 11, h - 62, 22, 6);
        setTimeout(() => {
          setShowReplay(false);
          setGulliY(0);
        }, 800);
        return;
      }

      raf = requestAnimationFrame(replayRender);
    };

    replayRender();

    return () => cancelAnimationFrame(raf);
  }, [showReplay, replayPath]);

  // Canvas rendering
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");

    let raf;
    const render = () => {
      const w = canvas.width, h = canvas.height;

      // Sky
      const grad = ctx.createLinearGradient(0, 0, 0, h);
      grad.addColorStop(0, "#ff9a5c");
      grad.addColorStop(1, "#2a2a3a");
      ctx.fillStyle = grad;
      ctx.fillRect(0, 0, w, h);

      // Ground
      ctx.fillStyle = "#4a2f1f";
      ctx.fillRect(0, h - 48, w, 48);

      // Wind lines
      if (Math.abs(wind) > 1) {
        ctx.strokeStyle = "rgba(255,255,255,0.25)";
        ctx.lineWidth = 1.5;
        for (let i = 0; i < 6; i++) {
          const y = 80 + i * 45;
          ctx.beginPath();
          ctx.moveTo(30, y);
          ctx.lineTo(w - 30, y + wind * 1.2);
          ctx.stroke();
        }
      }

      // Gulli
      ctx.fillStyle = "#f4f4f4";
      ctx.fillRect(w/2 - 11, h - 62 - gulliY, 22, 6);

      // Danda
      ctx.fillStyle = "#8b5a2b";
      ctx.fillRect(w/2 - 3, h - 105, 6, 48);

      if (impact) {
        ctx.fillStyle = "rgba(255, 230, 80, 0.85)";
        ctx.beginPath();
        ctx.arc(w/2, h - 78, 26, 0, Math.PI * 2);
        ctx.fill();
      }

      raf = requestAnimationFrame(render);
    };
    render();
    return () => cancelAnimationFrame(raf);
  }, [gulliY, impact, wind]);

  // Hint
  useEffect(() => {
    const hints = {
      idle: "👆 Tap to lift the gulli",
      lift: "⏳ Get ready to strike...",
      hit: "🔥 Tap when bar is centered!",
      result: "📊 Great shot! Next turn",
    };
    setFeedback(hints[gameState] || "");
  }, [gameState]);

  const resetGame = () => {
    // setScore(0);
    // setAttempts(5);
    // setPerfectHits(0);
    // setOpponentScores([]);
    // setGameState("setup");
    // setDoubleNext(false);
    // setSlowMotion(false);
    // setPowerUp(null);
    // setGulliY(0);
    // setPower(0);
    // setWind(generateWind());
    setScore(0);
    setAttempts(5);
    setPerfectHits(0);
    setGameHistory([]);           // Clear history
    setLiveOpponentScores([]);    // Clear live opponent scores
    setOpponentScores([]);        // Clear final standings
    setGameState("setup");
    setDoubleNext(false);
    setSlowMotion(false);
    setPowerUp(null);
    setGulliY(0);
    setPower(0);
    setWind(generateWind());
  };

  const shareScore = () => {
    const text = `🔥 I scored ${score} in Gulli Danda beating ${selectedOpponents.length} opponents! Can you beat me?`;
    if (navigator.share) {
      navigator.share({ title: "Gulli Danda", text });
    } else {
      navigator.clipboard.writeText(text);
      alert("Score copied!");
    }
  };

  // Setup Screen
  if (gameState === "setup") {
    return (
      <div className="min-h-screen bg-gray-950 text-white flex flex-col items-center justify-center p-6">
        <h1 className="text-lg lg:text-xl mb-4">🏏 Gulli Danda</h1>
        <p className="mb-8 text-lg text-center text-cyan-200">Select opponents to challenge (1-9)</p>

        <div className="grid grid-cols-3 lg:grid-cols-5 gap-1 mb-4 w-full">
          {COMPUTER_PLAYERS.map((p, i) => (
            <button
              key={i}
              onClick={() => {
                if (selectedOpponents.some(s => s.name === p.name)) {
                  setSelectedOpponents(prev => prev.filter(s => s.name !== p.name));
                } else if (selectedOpponents.length < 9) {
                  setSelectedOpponents(prev => [...prev, p]);
                }
              }}
              className={`p-2 rounded-md text-left transition-all ${selectedOpponents.some(s => s.name === p.name) ? "bg-green-600 ring-2 ring-green-400" : "bg-gray-800 hover:bg-gray-700"}`}
            >
              {p.emoji} {p.name}
            </button>
          ))}
        </div>

        <button
          onClick={() => {
            setWind(generateWind());
            setGameState("idle");
          }}
          disabled={selectedOpponents.length === 0}
          className="bg-orange-500 hover:bg-orange-600 disabled:bg-gray-600 px-2 py-2 rounded-md text-sm lg:text-lg w-56 lg:w-64 font-bold disabled:cursor-not-allowed"
        >
          Start Match vs {selectedOpponents.length} Opponents
        </button>

        <button onClick={(e) => {
            e.stopPropagation();
            setShowAbout(true);
          }} className="mt-4 py-2 px-2 text-sm lg:text-sm w-32 lg:w-48 bg-blue-500 text-yellow-200">How to Play</button>
        {showAbout && <GulliDandaAbout onClose={() => setShowAbout(false)} />}

      </div>
    );
  }

  return (
    <div
      onClick={handleTap}
      className={`gd-container relative min-h-screen bg-black text-white overflow-hidden ${shake ? "gd-shake" : ""}`}
    >
      {/* Header */}
      <div className="flex justify-between p-4 text-2xl font-mono border-b border-gray-800">
        <div>🏆 {score}</div>
        <div>🎯 {attempts}</div>
        <div>🔥 {bestScore}</div>
      </div>

      {/* Opponent Live Scores Bar - Place after the main header div */}
      {/* {liveOpponentScores.length > 0 && (
        <div className="h-40 px-4 py-2 bg-gray-900 flex gap-3 text-xs">
          {liveOpponentScores.map((opp, i) => (
            <div key={i} className="flex-shrink-0 bg-gray-800 px-3 py-1 rounded-full">
              {opp.emoji} {opp.name}: <span className="font-mono text-orange-400">{opp.score}</span>
            </div>
          ))}
        </div>
      )} */}

      <div className="px-4 py-3 bg-gray-900 border-b border-gray-700">
        <div className="text-xs text-gray-400 mb-2 font-medium">LIVE MATCH</div>
        <div className="flex flex-col gap-2">
          <div className="flex items-center justify-between bg-gradient-to-r from-orange-500/20 to-transparent border border-orange-400/30 px-4 py-2.5 rounded-2xl">
            <div className="flex items-center gap-3">
              <span className="text-2xl">👤</span>
              <span className="font-semibold text-white">You</span>
            </div>
            <span className="font-mono text-2xl font-bold text-orange-400">
              {score}
            </span>
          </div>

          {/* Computer Opponents Scores */}
          {liveOpponentScores.length > 0 && (
            <div className="flex flex-row flex-wrap gap-1 mt-1">
              {liveOpponentScores.map((opp, i) => (
                <div 
                  key={i} 
                  className="flex items-center justify-between bg-gray-800 hover:bg-gray-700 transition-colors px-4 py-2 rounded-xl"
                >
                  <div className="flex items-center gap-3">
                    <span className="text-xl">{opp.emoji}</span>
                    <span className="text-sm text-gray-300">{opp.name}</span>
                  </div>
                  <span className="font-mono text-lg font-semibold text-white">
                    {opp.score}
                  </span>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      <div className="flex justify-between px-3">
        <button
            onClick={(e) => {
            e.stopPropagation();
            alert(hint);
            }}
            className="mt-2 text-xs lg:text-sm w-20 lg:w-32 px-2 py-1 bg-gray-700 text-white rounded-md"
        >
            💡 Hint
        </button>

        <button
            onClick={(e) => {
            e.stopPropagation();
            setShowAbout(true);
            }}
            className="mt-2 text-xs lg:text-sm w-20 lg:w-32 px-2 py-1 bg-gray-700 text-white rounded-md"
        >
            ❓ Help
        </button>

        <button
          onClick={(e) => {
            e.stopPropagation();
            setSoundOn((prev) => !prev);
          }}
          className="mt-2 text-xs lg:text-sm w-20 lg:w-32 px-2 py-1 bg-gray-700 text-white rounded-md"
        >
          {soundOn ? "🔊" : "🔇"}
        </button>

         <button
            onClick={(e) => {
            e.stopPropagation();
            setShowHistory(true);
            }}
            className="mt-2 text-xs lg:text-sm w-20 lg:w-32 px-2 py-1 bg-gray-700 text-white rounded-md"
        >
            📜 History
        </button>
      </div>

      {/* ==================== HISTORY MODAL ==================== */}
      {showHistory && (
        <div className="absolute inset-0 bg-black/95 flex flex-col z-50">
          <div className="p-4 border-b border-gray-700 flex justify-between items-center">
            <h2 className="text-lg lg:text-xl font-bold flex items-center gap-3 text-yellow-200">
              📜 Match History
            </h2>
            <button
              onClick={() => setShowHistory(false)}
              className="w-12 lg:w-20 text-lg lg:text-xl bg-blue-500 text-gray-100 hover:text-white"
            >
              ✕
            </button>
          </div>

          <div className="flex-1 overflow-auto p-4">
            {gameHistory.length === 0 ? (
              <div className="text-center text-gray-400 mt-20">
                No turns played yet.<br />Play some shots to see history!
              </div>
            ) : (
              <div className="space-y-4">
                {gameHistory.map((turn, index) => (
                  <div
                    key={index}
                    className="bg-gray-900 border border-gray-700 rounded-2xl p-5"
                  >
                    <div className="flex justify-between items-center mb-4 border-b border-gray-700 pb-3">
                      <div className="text-lg font-semibold">
                        Turn {turn.turn} • {turn.timestamp}
                      </div>
                      <div className="text-orange-400 font-mono text-xl">
                        +{turn.yourPointsThisTurn}
                      </div>
                    </div>

                    
                    {/* Opponents Scores */}
                    <div className="grid grid-cols:3 lg:grid-cols-5 place-items-center space-y-2">
                      {/* Your Score */}
                      <div className="flex justify-between items-center mb-2 bg-orange-500/10 p-3 rounded-xl">
                        <div className="flex items-center gap-3">
                          <span className="text-3xl">👤</span>
                          <span className="font-semibold text-cyan-200">You</span>
                        </div>
                        <span className="ml-4 font-mono text-lg lg:text-xl font-bold text-orange-400">
                          {turn.yourScore}
                        </span>
                      </div>

                      {turn.opponents.map((opp, i) => (
                        <div
                          key={i}
                          className="flex justify-between gap-2 bg-gray-800 px-2 py-1 rounded-xl"
                        >
                          <div className="flex items-center gap-3">
                            <span className="text-lg lg:text-xl">{opp.emoji}</span>
                            <span className="text-gray-100">{opp.name}</span>
                          </div>
                          <span className="font-mono text-sm lg:text-lg font-semibold">
                            {opp.score}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className="p-4 border-t border-gray-700">
            <button
              onClick={() => setShowHistory(false)}
              className="w-32 lg:w-40 text-xs lg:text-sm bg-gray-700 hover:bg-gray-600 py-4 rounded-xl font-medium"
            >
              Close History
            </button>
          </div>
        </div>
      )}
      {/* Opponents */}
      {/* <div className="px-4 py-2 text-xs flex gap-2 flex-wrap bg-gray-900">
        {selectedOpponents.map((p, i) => (
          <span key={i} className="bg-gray-800 px-3 py-1 rounded-full">{p.emoji} {p.name}</span>
        ))}
      </div> */}

      <div className="flex-1 flex items-center justify-center relative">
        <canvas
          ref={canvasRef}
          width={320}
          height={420}
          className="rounded-3xl shadow-2xl border border-gray-700"
        />
      </div>

      {/* Power Bar */}
      {gameState === "hit" && (
        <div className="px-6 mb-4">
          <div className="h-4 bg-gray-800 rounded-full overflow-hidden">
            <div
              className="h-full bg-gradient-to-r from-green-400 via-yellow-400 to-red-400 transition-all"
              style={{ width: `${power}%` }}
            />
          </div>
          <div className="text-center text-xs mt-1 opacity-70">POWER {slowMotion && "(Slow Motion)"}</div>
        </div>
      )}

      <div className="text-center h-12 text-lg font-medium min-h-[3rem]">{feedback}</div>

      <div className="h-20 bg-gray-900 flex items-center justify-center text-xl tracking-widest border-t border-gray-700 active:bg-gray-700">
        TAP ANYWHERE
      </div>

      {/* Power-up popup */}
      {powerUp && (
        <div className="absolute top-24 left-1/2 -translate-x-1/2 bg-gradient-to-br from-orange-500 to-amber-500 text-black p-6 rounded-3xl shadow-2xl z-50 text-center">
          <div className="text-3xl mb-2">🎁 Power-up!</div>
          <div className="text-2xl font-bold">{powerUp.name}</div>
          <button
            onClick={(e) => { e.stopPropagation(); applyPowerUp(powerUp); }}
            className="mt-4 bg-white px-8 py-3 rounded-2xl font-bold"
          >
            Activate
          </button>
        </div>
      )}

      {/* ==================== LIVE OPPONENT ACTION POPUP ==================== */}
      {showOpponentAction && (
        <div className="absolute top-28 left-1/2 -translate-x-1/2 bg-gradient-to-br from-blue-600 to-indigo-600 text-white px-8 py-5 rounded-3xl shadow-2xl z-50 text-center border border-white/30 animate-pulse">
          <div className="text-4xl mb-2">{showOpponentAction.emoji}</div>
          <div className="font-bold text-xl">{showOpponentAction.name} hit!</div>
          <div className="text-2xl mt-1">
            +{showOpponentAction.points} 
            <span className="text-sm opacity-80 ml-2">
              → {showOpponentAction.newScore || "..."}
            </span>
          </div>
        </div>
      )}

      {/* Game Over */}
      {/* {gameState === "gameover" && (
        <div className="absolute inset-0 bg-black/95 flex flex-col items-center justify-center p-6 z-50 overflow-auto">
          <h1 className="text-2xl lg:text-5xl mb-2 text-yellow-200">🏁 Match Over</h1>
          <p className="text-xl lg:text-2xl mb-2 text-cyan-200">Your Score: <span className="text-orange-400 font-bold">{score}</span></p>

          <div className="w-full max-w-md mb-2">
            <h3 className="text-yellow-300 mb-3">Final Standings</h3>
            {[...opponentScores, { name: "You", score, emoji: "👤" }]
              .sort((a, b) => b.score - a.score)
              .map((p, idx) => (
                <div key={idx} className={`flex justify-between py-3 px-5 rounded-2xl mb-2 ${p.name === "You" ? "bg-orange-500/30 border border-orange-400" : "bg-gray-800"}`}>
                  <span>{idx === 0 ? "🥇 " : idx === 1 ? "🥈 " : idx === 2 ? "🥉 " : `${idx+1}. `}{p.emoji} {p.name}</span>
                  <span className="font-mono">{p.score}</span>
                </div>
              ))}
          </div>

          <div className="grid grid-cols-2 lg:grid-cols-4 gap-1 palce-items-center">
            <button onClick={resetGame} className="bg-white text-black py-4 rounded-lg font-bold text-xs lg:text-sm w-40 lg:w-64">Play Again</button>
            <button onClick={shareScore} className="bg-green-500 py-4 rounded-lg font-bold text-xs lg:text-sm w-40 lg:w-64g">📤 Challenge Friends</button>
            {bestFlight && <button onClick={replayBestHit} className="bg-purple-600 py-4 rounded-lg font-bold text-xs lg:text-sm w-40 lg:w-64">▶️ Replay Best Hit</button>}
            <button onClick={() => setSoundPack(soundPack === "desi" ? "modern" : "desi")} className="bg-gray-700 py-3 rounded-lg text-xs lg:text-sm w-40 lg:w-64">
              Sound Pack: {soundPack === "desi" ? "🎶 Desi Dhol" : "🌊 Modern"}
            </button>
          </div>

          {unlockedAchievements.length > 0 && (
            <div className="mt-8 text-center">
              <h3 className="text-yellow-300 mb-2">Achievements</h3>
              <div className="flex flex-wrap gap-4 justify-center">
                {unlockedAchievements.map((id, i) => {
                  const ach = ACHIEVEMENTS.find(a => a.id === id);
                  return ach ? <div key={i} className="text-xl lg:text-2xl" title={ach.desc}>{ach.icon} {ach.name}</div> : null;
                })}
              </div>
            </div>
          )}
        </div>
      )} */}

      {/* ==================== ENHANCED GAME OVER SCREEN ==================== */}
      {gameState === "gameover" && (
        <div className="absolute inset-0 bg-black/95 flex flex-col items-center justify-center p-6 z-50 overflow-auto">
          <h1 className="text-4xl lg:text-6xl mb-6 text-yellow-300 font-bold">🏁 Match Over</h1>

          <p className="text-2xl mb-8 text-center">
            Final Score: <span className="text-orange-400 font-bold text-4xl">{score}</span>
          </p>

          <div className="w-full max-w-md mb-10">
            <h3 className="text-yellow-300 text-xl mb-4 text-center">🏆 Final Standings</h3>

            {[...opponentScores, { name: "You", score, emoji: "👤" }]
              .sort((a, b) => b.score - a.score)
              .map((p, idx) => {
                const isWinner = idx === 0;
                const isYou = p.name === "You";

                return (
                  <div
                    key={idx}
                    className={`relative flex justify-between items-center py-4 px-6 rounded-2xl mb-3 text-lg transition-all duration-300 ${
                      isWinner 
                        ? "bg-gradient-to-r from-yellow-600 to-amber-500 border-2 border-yellow-300 shadow-2xl scale-[1.03]" 
                        : isYou 
                          ? "bg-orange-500/20 border border-orange-400" 
                          : "bg-gray-800 hover:bg-gray-700"
                    }`}
                  >
                    {/* Winner Sparkle Effect */}
                    {isWinner && (
                      <div className="absolute -top-2 -right-2 text-3xl animate-spin-slow">✨</div>
                    )}

                    <div className="flex items-center gap-4">
                      <span className="text-3xl">{p.emoji}</span>
                      <div>
                        <span className={`font-semibold ${isWinner ? "text-black" : ""}`}>
                          {p.name}
                        </span>
                        {isWinner && <span className="ml-2 text-black text-sm font-bold">(WINNER)</span>}
                      </div>
                    </div>

                    <div className="flex items-center gap-3">
                      <span className={`font-mono text-2xl font-bold ${isWinner ? "text-black" : "text-white"}`}>
                        {p.score}
                      </span>
                      {idx === 0 && <span className="text-2xl">🥇</span>}
                      {idx === 1 && <span className="text-2xl">🥈</span>}
                      {idx === 2 && <span className="text-2xl">🥉</span>}
                    </div>
                  </div>
                );
              })}
          </div>

          {/* Action Buttons */}
          <div className="grid grid-cols-2 gap-3 w-full max-w-md mb-8">
            <button 
              onClick={resetGame} 
              className="bg-white text-black py-4 rounded-2xl font-bold text-base active:scale-95 transition"
            >
              Play Again
            </button>

            <button 
              onClick={shareScore} 
              className="bg-green-500 py-4 rounded-2xl font-bold text-base active:scale-95 transition"
            >
              📤 Challenge Friends
            </button>

            {bestFlight && (
              <button 
                onClick={replayBestHit} 
                className="bg-purple-600 py-4 rounded-2xl font-bold text-base active:scale-95 transition col-span-2"
              >
                ▶️ Replay Best Hit
              </button>
            )}

            <button 
              onClick={() => setSoundPack(soundPack === "desi" ? "modern" : "desi")} 
              className="bg-gray-700 py-4 rounded-2xl text-sm active:scale-95 transition col-span-2"
            >
              Sound: {soundPack === "desi" ? "🎶 Desi Dhol" : "🌊 Modern"}
            </button>
          </div>

          {/* Achievements */}
          {unlockedAchievements.length > 0 && (
            <div className="mt-6 text-center w-full max-w-md">
              <h3 className="text-yellow-300 mb-3">Achievements Unlocked</h3>
              <div className="flex flex-wrap gap-4 justify-center">
                {unlockedAchievements.map((id, i) => {
                  const ach = ACHIEVEMENTS.find(a => a.id === id);
                  return ach ? (
                    <div key={i} className="text-2xl bg-gray-800 px-5 py-2 rounded-2xl" title={ach.desc}>
                      {ach.icon} {ach.name}
                    </div>
                  ) : null;
                })}
              </div>
            </div>
          )}
        </div>
      )}

      {/* Replay Modal */}
      {/* {showReplay && (
        <div className="absolute inset-0 bg-black/90 flex flex-col items-center justify-center z-[60]">
          <h2 className="text-2xl mb-6">Best Hit Replay</h2>
          <canvas ref={replayCanvasRef} width={320} height={300} className="rounded-2xl border border-gray-600" />
          <button onClick={() => setShowReplay(false)} className="mt-8 bg-red-500 px-8 py-3 rounded-2xl">Close Replay</button>
        </div>
      )} */}
      
      {/* ==================== REPLAY MODAL ==================== */}
      {showReplay && (
        <div className="absolute inset-0 bg-black/95 flex flex-col items-center justify-center z-[60] p-4">
          <h2 className="text-3xl mb-6 text-yellow-300">▶️ Best Hit Replay</h2>
          
          <canvas
            ref={replayCanvasRef}
            width={320}
            height={380}
            className="rounded-3xl border-4 border-purple-500 shadow-2xl bg-black"
          />

          <div className="mt-8 text-center text-sm text-gray-400">
            Watch your longest shot again
          </div>

          <button
            onClick={() => {
              setShowReplay(false);
              setGulliY(0);
            }}
            className="mt-10 bg-red-600 hover:bg-red-700 px-10 py-4 rounded-2xl font-bold text-lg"
          >
            Close Replay
          </button>
        </div>
      )}

      {showAbout && <GulliDandaAbout onClose={() => setShowAbout(false)} />}

      {/* Tutorial */}
      {showTutorial && (
        <div className="absolute inset-0 bg-black/90 flex items-center justify-center z-50 px-6">
          <div className="bg-gray-900 p-8 rounded-3xl max-w-sm w-full text-center">
            <h2 className="text-3xl mb-6">Quick Tutorial</h2>
            <p className="text-xl mb-10 leading-relaxed">{TUTORIAL_STEPS[tutorialStep]}</p>
            <div className="flex justify-between">
              <button onClick={() => { setShowTutorial(false); localStorage.setItem("gd_tutorial_done", "true"); }} className="text-gray-400">Skip</button>
              <button
                onClick={() => {
                  if (tutorialStep < TUTORIAL_STEPS.length - 1) {
                    setTutorialStep(p => p + 1);
                  } else {
                    setShowTutorial(false);
                    localStorage.setItem("gd_tutorial_done", "true");
                  }
                }}
                className="bg-white text-black px-10 py-3 rounded-2xl font-medium"
              >
                {tutorialStep === TUTORIAL_STEPS.length - 1 ? "Start Playing" : "Next"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default GulliDandaGame;